import { footerContainerStyles } from "@insite/content-library/Widgets/Footer/FooterContainer";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

footerContainerStyles.logoGridItem = {
    width: [6, 6, 6, 3, 2],
};

footerContainerStyles.linkList1GridItem = {
    width: [6, 6, 6, 3, 2],
};

footerContainerStyles.linkList2GridItem = {
    width: [6, 6, 6, 3, 2],
};

footerContainerStyles.linkList3GridItem = {
    width: [6, 6, 6, 3, 2],
};

footerContainerStyles.linkList4GridItem = {
    width: [12, 12, 12, 12, 4],
};

footerContainerStyles.subscribeGridItem = {
    width: 0,
};

footerContainerStyles.widgetGridContainer = {
    css: css`
        margin: 0 auto;
    `,
};

footerContainerStyles.logoWrapper = {
    css: css`
    width: 100%;`,
}
